<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-07-07 15:56:36
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-08-08 17:06:55
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/ES/ESapply/component/agreementListDialog.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!-- 查看协议弹框 -->
<template>
  <div>
    <eDialogVue
      dialogTitle="查看质量评价委托协议"
      :centerDialogVisible="agreementVisible"
      @resetPopupData="setResetPopupData"
      @submitPopupData="setSubmitPopupData"
      :popupWidth="'580px'"
      :isShowCancel="false"
    >
      <eTableList
        :loading="loading"
        :table-data="agreementList"
        :table-label="tableLabel"
        :indexShow="true"
      >
        <template v-slot:agreementName="slot">
          <div>
            <eui-btn
              font-size="12px"
              type="link"
              @click="handleBtn(slot.scope.row.agreementPath)"
              >{{ slot.scope.row.agreementName }}</eui-btn
            >
          </div>
        </template>
      </eTableList>
    </eDialogVue>
  </div>
</template>

<script>
import eDialogVue from '@/components/common/e-dialog.vue';
import eTableList from '../../../../components/common/e-table-list.vue';
import api from '../../../../api/evaluation/index';
export default {
  props: {
    agreementList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    agreementVisible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loading: false,
      tableData: [],
      tableLabel: [
        {
          label: '质量评价委托协议名称',
          align: 'center',
          slot: 'agreementName'
          // width: "60",
        }
      ]
    };
  },

  components: { eDialogVue, eTableList },

  computed: {},

  created() {},
  methods: {
    setResetPopupData() {
      this.$emit('resetPopupData', 2);
    },
    setSubmitPopupData() {
      this.$emit('submitPopupData', {});
    },
    async handleBtn(url) {
      let res = await api.getOssPath({ ossPrivateFilePath: url });
      if (res.code === '200') {
        window.open(res.data);
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
